import { RootState } from '../../RootState';
import selectRequiredSettings from '@spa/lib/store/settings/selectors/selectRequiredSettings';

const selectBuildId = (state: RootState): string | null => {
  const settings = selectRequiredSettings(state);

  return settings.buildId;
};

export default selectBuildId;
